/**
 * `crypto.randomUUID()` gibt es nur in sicheren Kontexten (https, oder
 * localhost) — ruft z. B. eine Testerin die App über die lokale Netzwerk-IP
 * per http:// auf (siehe Handy-Tests), ist die Funktion schlicht nicht
 * vorhanden und wirft "crypto.randomUUID is not a function". Fällt daher auf
 * `crypto.getRandomValues()` zurück, die überall verfügbar ist.
 */
export function erzeugeId(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
